import React, { useEffect, useState } from "react";
import OthersOutfitListView from "presentational/portfolio/OthersOutfitListView";
import { withStore } from "store/storeHandler";
import PropTypes from "prop-types";

OthersOutfitListForGuest.propTypes = {
  ownerName: PropTypes.string.isRequired
};

function OthersOutfitListForGuest(props) {
  const {
    ownerName,
    isLoading,
    isEnd,
    outfitList,
    OthersOutfitForGuestActions,
    AppErrorActions
  } = props;
  const [nowOwnerName, setNowOwnerName] = useState(null);

  useEffect(() => {
    changeOwnerName();
  });

  const changeOwnerName = async () => {
    if (ownerName === nowOwnerName) return null;
    setNowOwnerName(ownerName);

    try {
      await OthersOutfitForGuestActions.changeUser(ownerName);
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const handleClick = async () => {
    try {
      await OthersOutfitForGuestActions.getList();
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  return (
    <OthersOutfitListView
      list={outfitList}
      isLoading={isLoading}
      isEnd={isEnd}
      callNextListFn={handleClick}
    />
  );
}

export default withStore({
  stateMap: { othersOutfitForGuest: ["outfitList", "isLoading", "isEnd"] },
  dispatchMap: ["othersOutfitForGuest", "appError"]
})(OthersOutfitListForGuest);
